import classNames from 'classnames'
import { InfoElement } from 'components'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatNumber, formatPreciseValue, getDifferenceWithPrecision, thousandsSeparator } from 'utils'

import Box from '@mui/material/Box'

import { AVAILABLE_COLUMNS_TYPES } from './constants'
import { getCurrencyPerColumn, getTypePerColumn } from './utils'

interface Props {
  cellName: string
  column: string
  currency: string
  percentOfMax: any
  [prop: string]: any
}

function RankingsBoxTableCell({ cellName, column, currency, percentOfMax, ...data }: Props) {
  const { t: translate } = useTranslation()
  const columnType = getTypePerColumn(column)

  if (AVAILABLE_COLUMNS_TYPES.CURRENCY === columnType) {
    return <Box className={classNames('cell', `cell-${cellName}`)}>{formatNumber(data[column], translate)}</Box>
  }

  if (AVAILABLE_COLUMNS_TYPES.PERCENT === columnType) {
    return (
      <Box className={classNames('cell', `cell-${cellName}`)}>
        <InfoElement
          percentDifference={getDifferenceWithPrecision({
            number: data[column],
            suffix: '',
            translate,
          })}
        />
      </Box>
    )
  }

  if (AVAILABLE_COLUMNS_TYPES.PERCENT_SIMPLE === columnType) {
    return (
      <Box className={classNames('cell', `cell-${cellName}`)}>
        {
          getDifferenceWithPrecision({
            number: data[column],
            translate,
          }).value
        }
      </Box>
    )
  }

  if (AVAILABLE_COLUMNS_TYPES.PROGRESS === columnType) {
    return (
      <Box className={classNames('cell', `cell-${cellName}`)}>
        {data[column] >= 0 ? `${thousandsSeparator(Math.round(data[column]))}${getCurrencyPerColumn(column, currency)}` : '-'}
        <Box className="percentage-bar" style={{ width: `${percentOfMax[column]}%` }} />
      </Box>
    )
  }

  if (AVAILABLE_COLUMNS_TYPES.PROGRESS_FULL === columnType) {
    return (
      <Box className={classNames('cell', `cell-${cellName}`)}>
        {formatPreciseValue({
          number: data[column],
          precision: 2,
          translate,
        })}
        <Box className="percentage-bar" style={{ width: `${percentOfMax[column]}%` }} />
      </Box>
    )
  }

  return <Box className={classNames('cell', `cell-${cellName}`)}>{formatNumber(data[column], translate)}</Box>
}

export default RankingsBoxTableCell
